import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { IconCompanies, IconContacts, IconEvents, IconGroups, IconNews, IconJobs, } from '@xingternal/icons';
import { trackingURL } from '@xingternal/xing-tracking';
import { trackings } from '../../../tracking';
import { Item } from '../Item';
import { Section } from './components';
const navigationSuggestionData = {
    members: {
        icon: React.createElement(IconContacts, { width: 24, height: 24 }),
        url: '/search/members',
        text: 'DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_MEMBERS',
    },
    jobs: {
        icon: React.createElement(IconJobs, { width: 24, height: 24 }),
        url: '/jobs/search?paging_context=global_search',
        text: 'DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_JOBS',
    },
    companies: {
        icon: React.createElement(IconCompanies, { width: 24, height: 24 }),
        url: '/search/companies',
        text: 'DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_COMPANIES',
    },
    news: {
        icon: React.createElement(IconNews, { width: 24, height: 24 }),
        url: '/search/news',
        text: 'DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_NEWS',
    },
    events: {
        icon: React.createElement(IconEvents, { width: 24, height: 24 }),
        url: '/search/events',
        text: 'DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_EVENTS',
    },
    groups: {
        icon: React.createElement(IconGroups, { width: 24, height: 24 }),
        url: '/search/communities',
        text: 'DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_GROUPS',
    },
};
function NavigationSuggestionsSection({ baseI, highlightedIndex, intl: { formatMessage }, section: { title, items }, getItemProps, userId, }) {
    return (React.createElement(Section, { type: "navigation-suggestions", headline: title }, items.map(({ trackingToken, navigationSuggestion: { label } }, i) => {
        const { icon, url, text } = navigationSuggestionData[label];
        const position = baseI + i;
        return (React.createElement(Item, { icon: icon, getItemProps: getItemProps, key: trackingToken, data: {
                title: formatMessage({
                    id: text,
                }),
                url: trackingURL(url, 'advanced_search')(trackings),
                trackingToken,
                position,
                userId,
            }, isHighlighted: highlightedIndex === position }));
    })));
}
NavigationSuggestionsSection.propTypes = {
    baseI: PropTypes.number.isRequired,
    highlightedIndex: PropTypes.number,
    intl: PropTypes.object.isRequired,
    getItemProps: PropTypes.func.isRequired,
    userId: PropTypes.string.isRequired,
    section: PropTypes.shape({
        title: PropTypes.string.isRequired,
        items: PropTypes.arrayOf(PropTypes.shape({
            navigationSuggestion: PropTypes.shape({
                label: PropTypes.string.isRequired,
            }).isRequired,
            trackingToken: PropTypes.string.isRequired,
        })).isRequired,
    }).isRequired,
};
export default injectIntl(NavigationSuggestionsSection);
//# sourceMappingURL=NavigationSuggestions.js.map